export const homeParams = {
  applicant_name: null,
  applicant_cpf: null,
  start_date: null,
  end_date: null,
  status: null,
  result: null,
}

export const manualAnalisysAuditParams = {
  applicant_name: null,
  applicant_cpf: null,
  include_subordinate_reviews: false,
  status: null,
}

export const backgroundCheckSearchParams = {
  person_name: null,
  person_cpf: null,
  start_date: null,
  end_date: null,
  status: null,
}
